import { render, staticRenderFns } from "./Autenticacao.vue?vue&type=template&id=6c4ab365&"
import script from "./Autenticacao.vue?vue&type=script&lang=js&"
export * from "./Autenticacao.vue?vue&type=script&lang=js&"
import style0 from "./Autenticacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports